!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("ramda"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("ramda")) : t(e.react, e["@driftt/tide-core"], e.ramda);
    for (var o in n) {
      ("object" === typeof exports ? exports : e)[o] = n[o];
    }
  }
}(window, function (e, t, n) {
  return function (e) {
    var t = {};
    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
    }
    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        __webpack_require__.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 11);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var o;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;
      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var o = arguments[t];
          if (o) {
            var r = typeof o;
            if ("string" === r || "number" === r) e.push(o);else if (Array.isArray(o) && o.length) {
              var a = classNames.apply(null, o);
              a && e.push(a);
            } else if ("object" === r) for (var i in o) {
              n.call(o, i) && o[i] && e.push(i);
            }
          }
        }
        return e.join(" ");
      }
      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (o = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = o);
    }();
  }, function (e, t) {
    e.exports = n;
  }, function (e) {
    e.exports = {
      a: [{
        title: "Introducing: Drift Video",
        description: "Easily record and share personalized videos in 3 clicks to engage prospects, follow up on meetings, and more. Record directly in your browser or take videos on the go with the mobile app."
      }, {
        title: "Instantly follow up with on-the-go notifications",
        description: "Get notified when people are watching your video, no matter where you are. You'll never miss a chance to chat in real time with desktop and mobile notifications."
      }, {
        title: "Chat right from your videos with real-time messaging",
        description: "Once you know people are watching your video, chat with them in real time while they're engaged. They won't even have to pause the video to reply.",
        hasExternalNext: !0
      }]
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
              o = e[3];
            if (!o) return n;
            if (t && "function" === typeof btoa) {
              var r = function toComment(e) {
                  return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                }(o),
                a = o.sources.map(function (e) {
                  return "/*# sourceURL=" + o.sourceRoot + e + " */";
                });
              return [n].concat(a).concat([r]).join("\n");
            }
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);
        for (var o = {}, r = 0; r < this.length; r++) {
          var a = this[r][0];
          null != a && (o[a] = !0);
        }
        for (r = 0; r < e.length; r++) {
          var i = e[r];
          null != i[0] && o[i[0]] || (n && !i[2] ? i[2] = n : n && (i[2] = "(" + i[2] + ") and (" + n + ")"), t.push(i));
        }
      }, t;
    };
  }, function (e, t, n) {
    var o = {},
      r = function (e) {
        var t;
        return function () {
          return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
        };
      }(function () {
        return window && document && document.all && !window.atob;
      }),
      a = function (e) {
        var t = {};
        return function (e, n) {
          if ("function" === typeof e) return e();
          if ("undefined" === typeof t[e]) {
            var o = function (e, t) {
              return t ? t.querySelector(e) : document.querySelector(e);
            }.call(this, e, n);
            if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
              o = o.contentDocument.head;
            } catch (r) {
              o = null;
            }
            t[e] = o;
          }
          return t[e];
        };
      }(),
      i = null,
      s = 0,
      l = [],
      c = n(14);
    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
          a = o[r.id];
        if (a) {
          a.refs++;
          for (var i = 0; i < a.parts.length; i++) {
            a.parts[i](r.parts[i]);
          }
          for (; i < r.parts.length; i++) {
            a.parts.push(addStyle(r.parts[i], t));
          }
        } else {
          var s = [];
          for (i = 0; i < r.parts.length; i++) {
            s.push(addStyle(r.parts[i], t));
          }
          o[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }
    function listToStyles(e, t) {
      for (var n = [], o = {}, r = 0; r < e.length; r++) {
        var a = e[r],
          i = t.base ? a[0] + t.base : a[0],
          s = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
        o[i] ? o[i].parts.push(s) : n.push(o[i] = {
          id: i,
          parts: [s]
        });
      }
      return n;
    }
    function insertStyleElement(e, t) {
      var n = a(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var o = l[l.length - 1];
      if ("top" === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var r = a(e.insertAt.before, n);
        n.insertBefore(t, r);
      }
    }
    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = l.indexOf(e);
      t >= 0 && l.splice(t, 1);
    }
    function createStyleElement(e) {
      var t = document.createElement("style");
      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var o = function getNonce() {
          0;
          return n.nc;
        }();
        o && (e.attrs.nonce = o);
      }
      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }
    function addAttrs(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }
    function addStyle(e, t) {
      var n, o, r, a;
      if (t.transform && e.css) {
        if (!(a = "function" === typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
        e.css = a;
      }
      if (t.singleton) {
        var l = s++;
        n = i || (i = createStyleElement(t)), o = applyToSingletonTag.bind(null, n, l, !1), r = applyToSingletonTag.bind(null, n, l, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), o = function updateLink(e, t, n) {
        var o = n.css,
          r = n.sourceMap,
          a = void 0 === t.convertToAbsoluteUrls && r;
        (t.convertToAbsoluteUrls || a) && (o = c(o));
        r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
        var i = new Blob([o], {
            type: "text/css"
          }),
          s = e.href;
        e.href = URL.createObjectURL(i), s && URL.revokeObjectURL(s);
      }.bind(null, n, t), r = function r() {
        removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = createStyleElement(t), o = function applyToTag(e, t) {
        var n = t.css,
          o = t.media;
        o && e.setAttribute("media", o);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }
          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), r = function r() {
        removeStyleElement(n);
      });
      return o(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          o(e = t);
        } else r();
      };
    }
    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = r()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var r = [], a = 0; a < n.length; a++) {
          var i = n[a];
          (s = o[i.id]).refs--, r.push(s);
        }
        e && addStylesToDom(listToStyles(e, t), t);
        for (a = 0; a < r.length; a++) {
          var s;
          if (0 === (s = r[a]).refs) {
            for (var l = 0; l < s.parts.length; l++) {
              s.parts[l]();
            }
            delete o[s.id];
          }
        }
      };
    };
    var p = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
    function applyToSingletonTag(e, t, n, o) {
      var r = n ? "" : o.css;
      if (e.styleSheet) e.styleSheet.cssText = p(t, r);else {
        var a = document.createTextNode(r),
          i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
      }
    }
  }, function (e) {
    e.exports = {
      b: "Drift Automation",
      a: "Drift Automation can be your SDR, your sales trainer, and can help you make strategic decisions. You can hire the Qualification Bot to engage and qualify people on your website 24/7."
    };
  }, function (e, t, n) {
    e.exports = n.p + "assets/media/slide0.b20c74c0.png";
  }, function (e, t, n) {
    e.exports = n.p + "assets/media/slide1.b6dbd2da.png";
  }, function (e, t, n) {
    e.exports = n.p + "assets/media/slide2.858032ee.png";
  }, function (e, t, n) {
    e.exports = n(19);
  }, function (e, t, n) {
    var o = n(13);
    "string" === typeof o && (o = [[e.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(6)(o, r);
    o.locals && (e.exports = o.locals);
  }, function (e, t, n) {
    (e.exports = n(5)(!0)).push([e.i, ".marketable-moment--body-static-image {\n  background: var(--color-p1-10);\n  height: 288px;\n  margin: -16px -24px 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.marketable-moment--body-static-close {\n  position: absolute;\n  z-index: 1;\n  right: 16px;\n  top: 16px;\n}\n\n.marketable-moment--body-static-image  .marketable-moment--body-static-image-container--active {\n  visibility: visible;\n  transition: opacity .40s ease-in-out;\n  opacity: 1;\n}\n\n.tide-footer.marketable-moment--body-static-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border-top: 1px solid #EFF3F5;\n  padding-top: 24px;\n  margin: 0;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX",
      file: "style.css",
      sourcesContent: [".marketable-moment--body-static-image {\n  background: var(--color-p1-10);\n  height: 288px;\n  margin: -16px -24px 16px;\n  position: relative;\n  overflow: hidden;\n}\n\n.marketable-moment--body-static-close {\n  position: absolute;\n  z-index: 1;\n  right: 16px;\n  top: 16px;\n}\n\n.marketable-moment--body-static-image  .marketable-moment--body-static-image-container--active {\n  visibility: visible;\n  transition: opacity .40s ease-in-out;\n  opacity: 1;\n}\n\n.tide-footer.marketable-moment--body-static-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border-top: 1px solid #EFF3F5;\n  padding-top: 24px;\n  margin: 0;\n}\n"]
    }]);
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var n = t.protocol + "//" + t.host,
        o = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var r,
          a = t.trim().replace(/^"(.*)"$/, function (e, t) {
            return t;
          }).replace(/^'(.*)'$/, function (e, t) {
            return t;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (r = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? n + a : o + a.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")");
      });
    };
  }, function (e, t, n) {
    var o = n(16);
    "string" === typeof o && (o = [[e.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(6)(o, r);
    o.locals && (e.exports = o.locals);
  }, function (e, t, n) {
    (e.exports = n(5)(!0)).push([e.i, ".marketable-moment--body-carousel-image {\n  background: var(--color-p1-3);\n  height: 288px;\n  margin: -24px -24px 16px;\n  position: relative;\n}\n\n.marketable-moment--body-carousel-close {\n  position: absolute;\n  z-index: 1;\n  right: 16px;\n}\n\n.marketable-moment--body-carousel-image .marketable-moment--body-carousel-image-container {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.marketable-moment--body-carousel-image  .marketable-moment--body-carousel-image-container--active { \n  visibility: visible;\n  transition: opacity .40s ease-in-out;\n  opacity: 1;\n}\n\n.tide-footer.marketable-moment--body-carousel-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border-top: 1px solid #EFF3F5;\n  padding-top: 24px;\n  margin: 0;\n}\n\n.marketable-moment--body-carousel-slider-position {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: calc(100% / 2.1);\n}\n\n.marketable-moment--body-carousel-slider-position .carousel--position {\n  background: var(--color-p1-5);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.marketable-moment--body-carousel-slider-position .carousel--position.carousel--position--active {\n  background: var(--color-p1-6);\n}\n\n.tide-footer.marketable-moment--body-carousel-footer.marketable-moment--body-carousel-footer--first {\n  justify-content: flex-end;\n}\n\n.tide-footer.marketable-moment--body-carousel-footer button.marketable-moment-carousel-button {\n  margin-right: 0px;\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,6BAA6B;EAC7B,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB",
      file: "style.css",
      sourcesContent: [".marketable-moment--body-carousel-image {\n  background: var(--color-p1-3);\n  height: 288px;\n  margin: -24px -24px 16px;\n  position: relative;\n}\n\n.marketable-moment--body-carousel-close {\n  position: absolute;\n  z-index: 1;\n  right: 16px;\n}\n\n.marketable-moment--body-carousel-image .marketable-moment--body-carousel-image-container {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.marketable-moment--body-carousel-image  .marketable-moment--body-carousel-image-container--active { \n  visibility: visible;\n  transition: opacity .40s ease-in-out;\n  opacity: 1;\n}\n\n.tide-footer.marketable-moment--body-carousel-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border-top: 1px solid #EFF3F5;\n  padding-top: 24px;\n  margin: 0;\n}\n\n.marketable-moment--body-carousel-slider-position {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: calc(100% / 2.1);\n}\n\n.marketable-moment--body-carousel-slider-position .carousel--position {\n  background: var(--color-p1-5);\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.marketable-moment--body-carousel-slider-position .carousel--position.carousel--position--active {\n  background: var(--color-p1-6);\n}\n\n.tide-footer.marketable-moment--body-carousel-footer.marketable-moment--body-carousel-footer--first {\n  justify-content: flex-end;\n}\n\n.tide-footer.marketable-moment--body-carousel-footer button.marketable-moment-carousel-button {\n  margin-right: 0px;\n}"]
    }]);
  }, function (e, t, n) {
    var o = n(18);
    "string" === typeof o && (o = [[e.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(6)(o, r);
    o.locals && (e.exports = o.locals);
  }, function (e, t, n) {
    (e.exports = n(5)(!0)).push([e.i, ".tide-base-modal-content {\n  margin-top: 8px;\n  border: none;\n}\n\n.tide-base-modal-content .tide-icon-button.medium {\n  padding-top: 12px;\n}\n\n.marketable-moment-modal-header {\n  height: 8px;\n  width: 100%;\n  background: linear-gradient(94deg, #ed1886, #8711ff);\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n}\n\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;AACZ",
      file: "style.css",
      sourcesContent: [".tide-base-modal-content {\n  margin-top: 8px;\n  border: none;\n}\n\n.tide-base-modal-content .tide-icon-button.medium {\n  padding-top: 12px;\n}\n\n.marketable-moment-modal-header {\n  height: 8px;\n  width: 100%;\n  background: linear-gradient(94deg, #ed1886, #8711ff);\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 1;\n}\n\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }
    function _createClass(e, t, n) {
      return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }
    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function _inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _setPrototypeOf(e, t);
    }
    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" !== typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }
    function _createSuper(e) {
      return function () {
        var t,
          n = _getPrototypeOf(e);
        if (function _isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;
          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var o = _getPrototypeOf(this).constructor;
          t = Reflect.construct(n, arguments, o);
        } else t = n.apply(this, arguments);
        return _possibleConstructorReturn(this, t);
      };
    }
    n.r(t);
    var o = n(0),
      r = n.n(o),
      a = n(1),
      i = n(2),
      s = n.n(i),
      l = (n(12), n(7)),
      c = function DriftAutomationImage(e) {
        var t = e.width,
          n = void 0 === t ? "750" : t,
          o = e.height,
          a = void 0 === o ? "300" : o,
          i = e.className;
        return r.a.createElement("svg", {
          width: n,
          height: a,
          className: i,
          viewBox: "0 0 720 288",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, r.a.createElement("mask", {
          id: "mask0",
          maskType: "alpha",
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "720",
          height: "288"
        }, r.a.createElement("rect", {
          width: "720",
          height: "288",
          fill: "white"
        })), r.a.createElement("g", {
          mask: "url(#mask0)"
        }, r.a.createElement("path", {
          opacity: "0.245675",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-202.714 95.5975C-150.569 122.594 -111.99 122.594 -86.9788 95.5975C-49.4616 55.1034 -13.5722 -49.5414 4.64626 -88.0266C22.8647 -126.512 68.5421 -216.618 174.496 -140.163C236.997 -95.0628 236.73 -86.6533 255.181 -75.9752C268.009 -68.5514 282.796 -63.7359 342.178 -58.8511C486.975 -46.9402 391.569 187.635 550.468 187.635C709.366 187.635 650.105 150.202 795.953 137.332C795.953 137.332 830.726 131.251 845.556 106.997C860.386 82.7427 847.398 157.055 847.398 157.055L827.133 214.807L-212.386 157.055L-202.714 95.5975Z",
          fill: "url(#paint0_linear)"
        }), r.a.createElement("path", {
          d: "M-202.714 74.458C-122.865 108.695 -47.5428 82.2263 23.2544 -4.94852C129.45 -135.711 262.41 119.682 312.21 162.301C362.009 204.921 404.163 160.836 480.234 24.854C556.305 -111.128 645.14 -15.4092 717.606 -74.9066C761.297 -110.778 784.617 -124.558 800.77 -129.845",
          stroke: "url(#paint1_linear)",
          strokeWidth: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), r.a.createElement("path", {
          opacity: "0.310756",
          d: "M-202.714 95.5975C-150.569 122.594 -111.99 122.594 -86.9788 95.5975C-49.4616 55.1034 -13.5721 -49.5414 4.64629 -88.0266C22.8647 -126.512 68.5422 -216.618 174.496 -140.163C236.997 -95.0628 236.73 -86.6533 255.181 -75.9752C268.009 -68.5514 282.796 -63.7359 342.178 -58.8511C486.975 -46.9402 391.569 187.635 550.468 187.635C709.366 187.635 650.105 150.202 795.953 137.332",
          stroke: "url(#paint2_linear)",
          strokeWidth: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), r.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M-202.714 -16.9913C-148.528 -11.182 -84.3563 22.7427 -10.1991 84.7828C101.037 177.843 193.88 37.0904 291.788 107.467C389.697 177.843 400.971 245.953 473 245.953C545.029 245.953 541.03 236.251 635.715 111.793C672.866 62.96 698.123 52.3012 714.984 50.4329C741.097 47.5394 751.313 63.0164 791.119 58.8285C817.766 56.0251 836.074 53.2266 846.046 50.4329",
          fill: "url(#paint3_linear)"
        }), r.a.createElement("path", {
          opacity: "0.6",
          d: "M-202.714 -13.3044C-148.528 -7.49501 -84.3563 26.4297 -10.1991 88.4698C101.037 181.53 193.88 40.7774 291.788 111.154C389.697 181.53 412.283 251 478.859 251C545.436 251 548.707 235.612 643.392 111.154C680.543 62.3206 693.325 58.8898 710.187 57.0215C736.299 54.128 768.936 62.5155 791.119 62.5155C819.951 62.5155 836.074 56.9135 846.046 54.1198",
          stroke: "url(#paint4_linear)",
          strokeWidth: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), r.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M120.042 251.608H174.116C177.328 251.608 179.932 249.142 179.932 246.112V182.356C179.932 179.32 177.323 176.859 174.111 176.859H132.651V168.896C132.651 168.34 132.2 167.889 131.644 167.889H123.194V152.429C126.867 151.198 129.498 147.875 129.498 143.97C129.498 139.016 125.265 135 120.042 135C114.82 135 110.586 139.016 110.586 143.97C110.586 147.875 113.217 151.198 116.89 152.429V167.889H108.44C107.884 167.889 107.434 168.34 107.434 168.896V176.859H62.81C59.6012 176.859 57 179.325 57 182.356V246.112C57 249.147 59.596 251.608 62.8157 251.608H115.107V258.19C92.663 259.979 85.7201 276.09 82.8637 289.76L151.339 289.836C148.549 276.317 142.131 260.451 120.042 258.275V251.608Z",
          fill: "url(#paint5_linear)"
        }), r.a.createElement("rect", {
          x: "73.1058",
          y: "195.018",
          width: "91.4111",
          height: "27.2809",
          rx: "10.0631",
          fill: "white"
        }), r.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M92.663 219.025C98.3812 219.025 103.017 214.628 103.017 209.204C103.017 203.78 98.3812 199.383 92.663 199.383C86.9447 199.383 82.3092 203.78 82.3092 209.204C82.3092 214.628 86.9447 219.025 92.663 219.025Z",
          fill: "#0071EB"
        }), r.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M142.131 219.025C147.849 219.025 152.485 214.628 152.485 209.204C152.485 203.78 147.849 199.383 142.131 199.383C136.413 199.383 131.777 203.78 131.777 209.204C131.777 214.628 136.413 219.025 142.131 219.025Z",
          fill: "#0071EB"
        }), r.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M92.663 219.025C98.3812 219.025 103.017 214.628 103.017 209.204C103.017 203.78 98.3812 199.383 92.663 199.383C86.9447 199.383 82.3092 203.78 82.3092 209.204C82.3092 214.628 86.9447 219.025 92.663 219.025Z",
          fill: "#353F45"
        }), r.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M142.131 219.025C147.849 219.025 152.485 214.628 152.485 209.204C152.485 203.78 147.849 199.383 142.131 199.383C136.413 199.383 131.777 203.78 131.777 209.204C131.777 214.628 136.413 219.025 142.131 219.025Z",
          fill: "#353F45"
        })), r.a.createElement("defs", null, r.a.createElement("linearGradient", {
          id: "paint0_linear",
          x1: "-166.547",
          y1: "-291.979",
          x2: "-166.547",
          y2: "3.33736",
          gradientUnits: "userSpaceOnUse"
        }, r.a.createElement("stop", {
          stopColor: "#74FFBB",
          stopOpacity: "0.227819"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#F0FDF7",
          stopOpacity: "0.0131105"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#F2FDF8",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#F2FDF8",
          stopOpacity: "0.01"
        })), r.a.createElement("linearGradient", {
          id: "paint1_linear",
          x1: "395.086",
          y1: "305.887",
          x2: "538.296",
          y2: "-203.62",
          gradientUnits: "userSpaceOnUse"
        }, r.a.createElement("stop", {
          stopColor: "#A8E34C",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "0.344875",
          stopColor: "#8DCE40",
          stopOpacity: "0.0424771"
        }), r.a.createElement("stop", {
          offset: "0.533716",
          stopColor: "#87C93D"
        }), r.a.createElement("stop", {
          offset: "0.878418",
          stopColor: "#8DCE40",
          stopOpacity: "0.171247"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#E5FFF3",
          stopOpacity: "0.01"
        })), r.a.createElement("linearGradient", {
          id: "paint2_linear",
          x1: "274.097",
          y1: "370.485",
          x2: "510.318",
          y2: "-274.596",
          gradientUnits: "userSpaceOnUse"
        }, r.a.createElement("stop", {
          stopColor: "#A8E34C",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "0.257189",
          stopColor: "#8DCE40",
          stopOpacity: "0.0424771"
        }), r.a.createElement("stop", {
          offset: "0.533716",
          stopColor: "#59A62B"
        }), r.a.createElement("stop", {
          offset: "0.814461",
          stopColor: "#8DCE40",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#E5FFF3",
          stopOpacity: "0.01"
        })), r.a.createElement("linearGradient", {
          id: "paint3_linear",
          x1: "-218.976",
          y1: "61.0091",
          x2: "-217.5",
          y2: "312.518",
          gradientUnits: "userSpaceOnUse"
        }, r.a.createElement("stop", {
          stopColor: "#CCFFE6",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "0.630241",
          stopColor: "#74FFBB",
          stopOpacity: "0.0850907"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#F0FDF7",
          stopOpacity: "0.0131105"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#F2FDF8",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#F2FDF8",
          stopOpacity: "0.01"
        })), r.a.createElement("linearGradient", {
          id: "paint4_linear",
          x1: "298.013",
          y1: "386.133",
          x2: "428.666",
          y2: "-120.863",
          gradientUnits: "userSpaceOnUse"
        }, r.a.createElement("stop", {
          stopColor: "#A8E34C",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "0.247908",
          stopColor: "#8DCE40",
          stopOpacity: "0.01"
        }), r.a.createElement("stop", {
          offset: "0.487428",
          stopColor: "#59A62B"
        }), r.a.createElement("stop", {
          offset: "0.615797",
          stopColor: "#8DCE40",
          stopOpacity: "0.784828"
        }), r.a.createElement("stop", {
          offset: "0.73438",
          stopColor: "#CEF2C5",
          stopOpacity: "0.0665155"
        }), r.a.createElement("stop", {
          offset: "0.81095",
          stopColor: "#D0F3C8",
          stopOpacity: "0.0625628"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#E5FFF3",
          stopOpacity: "0.01"
        })), r.a.createElement("linearGradient", {
          id: "paint5_linear",
          x1: "235.133",
          y1: "216.364",
          x2: "90.299",
          y2: "95.1969",
          gradientUnits: "userSpaceOnUse"
        }, r.a.createElement("stop", {
          stopColor: "#B4EC51"
        }), r.a.createElement("stop", {
          offset: "1",
          stopColor: "#429321"
        }))));
      },
      p = function (e) {
        _inherits(StaticBody, o["Component"]);
        var t = _createSuper(StaticBody);
        function StaticBody() {
          return _classCallCheck(this, StaticBody), t.apply(this, arguments);
        }
        return _createClass(StaticBody, [{
          key: "render",
          value: function render() {
            var e = this.props,
              t = e.lastStepComponent,
              n = e.onClose,
              i = t || null;
            return r.a.createElement(o.Fragment, null, r.a.createElement(a.Div, {
              className: "marketable-moment--body-static-image"
            }, r.a.createElement(c, {
              className: s()("marketable-moment--body-static-image-container", "marketable-moment--body-static-image-container--active")
            })), r.a.createElement(a.IconButton, {
              onClick: n,
              className: "marketable-moment--body-static-close",
              width: 16,
              icon: "close"
            }), r.a.createElement(a.Div, {
              className: "marketable-moment--body-static-text"
            }, r.a.createElement(a.H3, null, l.b), r.a.createElement(a.P, null, l.a)), r.a.createElement(a.Footer, {
              className: "marketable-moment--body-static-footer"
            }, r.a.createElement(i, null)));
          }
        }]), StaticBody;
      }(),
      u = n(3),
      d = n(4),
      m = n(8),
      f = n.n(m),
      A = n(9),
      y = n.n(A),
      b = n(10),
      C = n.n(b),
      h = (n(15), [f.a, y.a, C.a]),
      E = function (e) {
        _inherits(CarouselBody, o["Component"]);
        var t = _createSuper(CarouselBody);
        function CarouselBody(e) {
          var n;
          return _classCallCheck(this, CarouselBody), (n = t.call(this, e)).resolveVisibleIndex = function () {
            var e = n.state ? n.state.currentIndex : 0,
              t = n.resolvePreviousIndex(e),
              o = n.resolvePreviousIndex(t),
              r = n.resolveNextIndex(e);
            return [o, t, e, r, n.resolveNextIndex(r)];
          }, n.onPrev = function () {
            n.setState(function (e) {
              var t = e.currentIndex;
              return {
                back: !0,
                next: !1,
                currentIndex: n.resolvePreviousIndex(t)
              };
            }, n.delayResolveVisibleIndexes);
          }, n.onNext = function () {
            n.setState(function (e) {
              var t = e.currentIndex;
              return {
                currentIndex: n.resolveNextIndex(t),
                back: !1,
                next: !0
              };
            }, n.delayResolveVisibleIndexes);
          }, n.resolveNextIndex = function (e) {
            var t = n.props.slides;
            return e === (t ? t.length : d.a.length) - 1 ? 0 : e + 1;
          }, n.resolvePreviousIndex = function (e) {
            return 0 === e ? 0 : e - 1;
          }, n.state = {
            currentIndex: 0,
            back: !1,
            next: !1,
            visibleIndex: n.resolveVisibleIndex()
          }, n;
        }
        return _createClass(CarouselBody, [{
          key: "render",
          value: function render() {
            var e = this.state.currentIndex,
              t = this.props,
              n = t.lastStepComponent,
              i = t.slides,
              l = n || null,
              c = i ? i[e] : d.a[e],
              p = c && c.image || h[e],
              m = i ? i.length : d.a.length,
              f = 0 === e;
            return r.a.createElement(o.Fragment, null, r.a.createElement(a.Div, {
              className: "marketable-moment--body-carousel-image"
            }, r.a.createElement(a.Div, {
              className: s()("marketable-moment--body-carousel-image-container", "marketable-moment--body-carousel-image-container--active")
            }, r.a.createElement("img", {
              src: p,
              className: "carousel-image",
              alt: ""
            }))), r.a.createElement(a.Div, {
              className: "marketable-moment--body-carousel-text"
            }, r.a.createElement(a.H3, null, c.title), r.a.createElement(a.P, null, c.description, Object(u.isNil)(c.learnMore) ? null : r.a.createElement(a.A, {
              href: c.learnMore,
              target: "_blank",
              rel: "noopener noreferer"
            }, "Learn more."))), r.a.createElement(a.Footer, {
              className: s()("marketable-moment--body-carousel-footer", {
                "marketable-moment--body-carousel-footer--first": f
              })
            }, !f && r.a.createElement(a.Button, {
              className: "marketable-moment-carousel-button",
              type: "tertiary",
              onClick: this.onPrev
            }, "Back"), r.a.createElement(a.Div, {
              className: "marketable-moment--body-carousel-slider-position"
            }, Object(u.times)(function (t) {
              return r.a.createElement(a.Div, {
                className: s()("carousel--position", {
                  "carousel--position--active": e === t
                }),
                key: t
              });
            }, m)), c.hasExternalNext && e === m - 1 ? r.a.createElement(l, null) : r.a.createElement(a.Button, {
              className: "marketable-moment-carousel-button",
              type: "secondary",
              onClick: this.onNext
            }, "Next")));
          }
        }]), CarouselBody;
      }(),
      v = (n(17), {
        static: p,
        carousel: E
      }),
      g = function (e) {
        _inherits(MarketableMomentModal, o["Component"]);
        var t = _createSuper(MarketableMomentModal);
        function MarketableMomentModal() {
          return _classCallCheck(this, MarketableMomentModal), t.apply(this, arguments);
        }
        return _createClass(MarketableMomentModal, [{
          key: "render",
          value: function render() {
            var e = this.props,
              t = e.isOpen,
              n = e.onChange,
              o = e.type,
              i = void 0 === o ? "carousel" : o,
              s = e.body,
              l = e.slides,
              c = e.lastStepComponent,
              p = v[i];
            return r.a.createElement(a.Modal, {
              open: t,
              onClose: n,
              size: "medium",
              className: "marketable-moment-modal"
            }, r.a.createElement(a.Div, {
              className: "marketable-moment-modal-header"
            }), r.a.createElement(p, {
              body: s,
              onClose: n,
              slides: l,
              lastStepComponent: c
            }));
          }
        }]), MarketableMomentModal;
      }();
    n.d(t, "MarketableMomentModal", function () {
      return g;
    });
  }]);
});